import { render, staticRenderFns } from "./cancelLack.vue?vue&type=template&id=4597fa2e&scoped=true&"
import script from "./cancelLack.vue?vue&type=script&lang=js&"
export * from "./cancelLack.vue?vue&type=script&lang=js&"
import style0 from "./cancelLack.vue?vue&type=style&index=0&id=4597fa2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4597fa2e",
  null
  
)

export default component.exports